import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function NcertBooks() {

    const pageTitleText = "JEE NCERT Books ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="ncert-book" 
      />

    </>
  );
} 

export default NcertBooks;